import { render, staticRenderFns } from "./QualityControl.vue?vue&type=template&id=5df75afd&"
import script from "./QualityControl.vue?vue&type=script&lang=js&"
export * from "./QualityControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports